"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsAutoCompleteSearch = void 0;
/* eslint-disable sonarjs/no-all-duplicated-branches */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/cognitive-complexity */
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const ListItem_1 = require("../ListItem");
const className_1 = require("../../utils/className");
const LoadingLogo_1 = require("../LoadingLogo");
const useResize_1 = require("../../hooks/useResize");
function SmlsAutoCompleteSearch({ id, textLabel, onFocusMobilePlaceholder = 'Digite seu país', onFocusDesktopPlaceholder, errorMessage = 'Error message', className = '', initialList = [], notFoundTitle = 'Não encontramos nenhum resultado.', notFoundSubtitle = 'Que tal tentar uma nova busca?', expandOnEnter = false, placeholder, disabled = false, value = '', icon, forceError = false, forceFocus, inputId, notFoundSearchTextId, inputErrorId, loadingLogoId, onStartSearch = (search) => search.length > 2, onSearch = () => undefined, renderItemDisabled = (item) => (item === null || item === void 0 ? void 0 : item.disabled) || false, onSelectedItem = () => undefined, onValid = () => undefined, onFocus, onBlur, expansible, }) {
    const [dropdownOpen, setDropdownOpen] = react_1.useState(false);
    const [isTyping, setIsTyping] = react_1.useState(false);
    const [isFilled, setIsFilled] = react_1.useState(false);
    const [innerValue, setInnerValue] = react_1.useState(value);
    const [isFocused, setIsFocused] = react_1.useState(false);
    const [isValidInput, setIsValidInput] = react_1.useState(true);
    const [listOfItems, setListOfItems] = react_1.useState([]);
    const [isLoading, setIsLoading] = react_1.useState(false);
    const thisRef = react_1.useRef(null);
    const inputRef = react_1.useRef(null);
    const innerInputRef = react_1.useRef(null);
    const { width } = useResize_1.useWindowSize();
    const isDesktop = width > 992;
    const [isExpanded, setIsExpanded] = react_1.useState(false);
    const isNotFound = listOfItems.length === 0 && innerValue.length > 2 && !isValidInput;
    const [expandedItemHover, setExpandedItemHover] = react_1.useState();
    const [selectedMobileItem, setSelectedMobileItem] = react_1.useState('');
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const onComponentFocus = react_1.useCallback(() => {
        if (onFocus)
            onFocus();
        setIsFocused(true);
    }, [onFocusDesktopPlaceholder]);
    const disableOutline = react_1.useCallback(() => {
        if (onBlur)
            onBlur(innerValue);
        setIsFocused(false);
    }, [innerValue]);
    const handleDebouncedValue = () => __awaiter(this, void 0, void 0, function* () {
        const hasValue = innerValue.length > 0;
        if (!hasValue || !isTyping || !onStartSearch(innerValue)) {
            setIsTyping(false);
            setIsLoading(false);
            setListOfItems([]);
            return;
        }
        try {
            const foundedItems = yield onSearch(innerValue);
            if (!foundedItems)
                throw new Error();
            const hasResults = foundedItems ? foundedItems.length > 0 : false;
            setListOfItems(foundedItems);
            setIsValidInput(hasResults);
            onValid(hasResults);
        }
        catch (_a) {
            setListOfItems([]);
        }
        finally {
            setIsFilled(hasValue);
            setIsTyping(false);
            setIsLoading(false);
        }
    });
    react_1.useEffect(() => {
        if (!innerValue.length) {
            onStartSearch(innerValue);
            return setIsLoading(false);
        }
        const debounceTimeout = setTimeout(handleDebouncedValue, 1000);
        return () => {
            clearTimeout(debounceTimeout);
        };
    }, [innerValue]);
    react_1.useEffect(() => {
        setInnerValue(value);
        setIsValidInput(true);
    }, [value]);
    react_1.useEffect(() => {
        if (isTyping || isFocused) {
            setDropdownOpen(true);
        }
    }, [isTyping, isFocused]);
    const handleOnChange = react_1.useCallback((event) => {
        const text = event.target.value;
        if (text.length > 2)
            setIsLoading(true);
        setIsTyping(true);
        setInnerValue(text);
        setListOfItems([]);
    }, []);
    const handleOnKeyDown = (event) => {
        var _a, _b, _c, _d, _e;
        if (event.key === 'ArrowDown' && thisRef.current) {
            const next = (_b = (_a = event.currentTarget.parentElement) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === null || _b === void 0 ? void 0 : _b.children[0];
            if (next) {
                next.focus();
            }
        }
        if (event.key === 'ArrowUp' && thisRef.current) {
            const next = (_d = (_c = event.currentTarget.parentElement) === null || _c === void 0 ? void 0 : _c.previousElementSibling) === null || _d === void 0 ? void 0 : _d.children[0];
            if (next) {
                next.focus();
            }
            else {
                const inp = (_e = inputRef.current) === null || _e === void 0 ? void 0 : _e.children[0];
                if (inp) {
                    inp.focus();
                }
            }
        }
    };
    const handleInputKeyDown = (event) => {
        if (event.key === 'ArrowDown' && thisRef.current) {
            const next = thisRef.current.children[0].children[0];
            if (next) {
                next.focus();
            }
        }
        if (event.key === 'Escape' && dropdownOpen) {
            toggle();
        }
    };
    const handleItemClick = react_1.useCallback((item) => {
        setInnerValue(item.title);
        onSelectedItem(item);
        setDropdownOpen(false);
        setIsTyping(false);
        setIsValidInput(true);
    }, [innerValue, value]);
    const handleItemFocus = (expandir, label) => {
        setSelectedMobileItem('');
        let itemArray;
        if (listOfItems.length === 0) {
            const items = initialList.map((config) => config.items);
            itemArray = [];
            items.forEach((array) => itemArray.push(...array));
        }
        else {
            itemArray = listOfItems;
        }
        const itemHover = itemArray && itemArray.filter((item) => item.title === label);
        if (expandir) {
            setExpandedItemHover(itemHover[0]);
            setSelectedMobileItem(() => itemHover[0].title);
        }
        setSelectedMobileItem(() => itemHover[0].title);
        setIsExpanded(expandir);
    };
    react_1.useEffect(() => {
        var _a;
        if (forceFocus && innerInputRef) {
            setDropdownOpen(true);
            (_a = innerInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [forceFocus, innerInputRef]);
    return (react_1.default.createElement("div", { className: className_1.mapToCssModules([
            'autocomplete-search',
            className,
            expandOnEnter ? 'expanded' : '',
            !isDesktop && dropdownOpen ? 'dropdown-mobile' : 'input-group',
            disabled ? 'disabled' : '',
            isTyping ? 'typing' : '',
            isFilled && isDesktop ? 'filled' : '',
            isFocused ? 'input-outline' : '',
            isDesktop &&
                ((!isValidInput && !dropdownOpen) || (forceError && !dropdownOpen))
                ? 'error'
                : '',
        ]) },
        textLabel && (isDesktop || (!isDesktop && !dropdownOpen)) && (react_1.default.createElement("label", { htmlFor: textLabel }, textLabel)),
        react_1.default.createElement(reactstrap_1.Dropdown, { id: id, isOpen: dropdownOpen, toggle: toggle },
            react_1.default.createElement("div", { className: "dropdown-toggle", ref: inputRef },
                !isDesktop && !dropdownOpen && icon,
                react_1.default.createElement(reactstrap_1.Input, { value: innerValue, disabled: disabled, onChange: handleOnChange, placeholder: 
                    // eslint-disable-next-line no-nested-ternary
                    !isDesktop && dropdownOpen
                        ? onFocusMobilePlaceholder
                        : isFocused
                            ? onFocusDesktopPlaceholder
                            : placeholder, onFocus: onComponentFocus, onFocusCapture: () => {
                        if (!isDesktop)
                            setTimeout(() => window.scrollTo(0, 0), 150);
                    }, onBlur: disableOutline, onKeyDown: handleInputKeyDown, autoComplete: "off", id: inputId, innerRef: innerInputRef, onClick: () => {
                        if (!disabled && !dropdownOpen) {
                            toggle();
                        }
                    } }),
                !isDesktop && dropdownOpen && (react_1.default.createElement("i", { onClick: () => {
                        if (!isValidInput)
                            setInnerValue('');
                        toggle();
                    }, className: "material-icons notranslate" }, "close"))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("ul", { className: `dropdown-menu expansible ${isLoading ? 'is-loading-dropdown' : ''}`, ref: thisRef },
                    isLoading && (react_1.default.createElement("div", { className: "dropdown-menu-loading" },
                        react_1.default.createElement(LoadingLogo_1.SmlsLoadingLogo, { id: loadingLogoId }))),
                    !isLoading && (react_1.default.createElement("div", { className: "dropdown-search-list" },
                        (innerValue.length === 0 ||
                            (isValidInput && !listOfItems.length)) &&
                            initialList &&
                            initialList.map((suggestion) => (react_1.default.createElement("div", { className: "dropdown-menu-initial-list", key: suggestion.label }, suggestion.items.length ? (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("label", { id: suggestion.labelId }, suggestion.label),
                                suggestion.items.map((item) => {
                                    const itemDisabled = renderItemDisabled(item);
                                    return (react_1.default.createElement(ListItem_1.SmlsListItem, { type: "text", resultText: item.cornerText, id: item.id, item: item.title, caption: item.subtitle, label: item.title, 
                                        // eslint-disable-next-line prettier/prettier
                                        icon: react_1.default.createElement("i", { className: "material-icons" }, item.iconName), key: `${suggestion.label}-${item.title}`, disabled: itemDisabled, onClick: () => handleItemClick(item), onKeyDown: handleOnKeyDown, expansible: expansible, onExpanded: handleItemFocus, expandedTitleFirst: item.expandedTitleFirst, expandedDescriptionFirst: item.expandedDescriptionFirst, expandedTitleSecond: item.expandedTitleSecond, expandedDescriptionSecond: item.expandedDescriptionSecond, isOpenItem: item.title === selectedMobileItem }));
                                }))) : ('')))),
                        listOfItems.length > 0 &&
                            listOfItems.map((item) => {
                                const itemDisabled = renderItemDisabled(item);
                                return (react_1.default.createElement(ListItem_1.SmlsListItem, { type: "text", resultText: item.cornerText, id: item.id, item: item.title, caption: item.subtitle, label: item.title, icon: react_1.default.createElement("i", { className: "material-icons" }, item.iconName), key: item.title, disabled: itemDisabled, onClick: () => handleItemClick(item), onKeyDown: handleOnKeyDown, expansible: expansible, onExpanded: handleItemFocus, expandedTitleFirst: item.expandedTitleFirst, expandedDescriptionFirst: item.expandedDescriptionFirst, expandedTitleSecond: item.expandedTitleSecond, expandedDescriptionSecond: item.expandedDescriptionSecond, isOpenItem: item.title === selectedMobileItem }));
                            }),
                        isNotFound && (react_1.default.createElement("div", { className: "dropdown-menu-not-found", id: notFoundSearchTextId },
                            notFoundTitle && react_1.default.createElement("p", null, notFoundTitle),
                            notFoundSubtitle && react_1.default.createElement("p", null, notFoundSubtitle))))),
                    isDesktop && expansible && !isLoading && !isNotFound && (react_1.default.createElement("div", { className: `dropdown-search-content ${isExpanded ? 'show' : ''}` },
                        react_1.default.createElement("div", { className: "text-box" },
                            react_1.default.createElement("p", { className: "title" }, expandedItemHover
                                ? expandedItemHover.expandedTitleFirst
                                : ''),
                            react_1.default.createElement("p", { className: "description" }, expandedItemHover
                                ? expandedItemHover.expandedDescriptionFirst
                                : ''),
                            react_1.default.createElement("p", { className: "title" }, expandedItemHover
                                ? expandedItemHover.expandedTitleSecond
                                : ''),
                            react_1.default.createElement("p", { className: "description" }, expandedItemHover
                                ? expandedItemHover.expandedDescriptionSecond
                                : ''))))))),
        isDesktop && (react_1.default.createElement("div", { className: "input-error", id: inputErrorId }, (!isValidInput || forceError) && !dropdownOpen && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("i", { className: "material-icons notranslate" }, "\uE001"),
            react_1.default.createElement("label", { htmlFor: "input-text" }, errorMessage)))))));
}
exports.SmlsAutoCompleteSearch = SmlsAutoCompleteSearch;
//# sourceMappingURL=index.js.map